export enum GLProcessTypeEnum {
    EnrollmentFee = 1,
    CycleFee = 2,
    ProrateFee = 3,
    MembershipFee = 4,
    UpgradeFee = 6,
    RenewalFee = 10,
    FreezeFee = 11,
    NewMemberAdminFees = 23,
    RenewalAdminFees = 24,
    UpgradeAdminFees = 25,
    AddOnCycleFee = 46,
    AddOnProrateFee = 47,
    AddOnEnrolFee = 48,
    AddOnProcessFee = 48,
    ContactServiceCycleFee = 53,
    MonthInHandFee = 55,
    ContactServicePIF = 68,
    ContactServiceAdminFee = 69,
    ContactServiceProrateFee = 70,
    ContactServiceUpfrontFee = 71,
    ProcessFee = 73
}